// extracted by mini-css-extract-plugin
export var cPageContainer = "PageContainer-module--c-page-container--929f9";
export var cPageContainerGrey = "PageContainer-module--c-page-container--grey--413b1";
export var cPageContainerWhite = "PageContainer-module--c-page-container--white--f4969";